import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import Header from "./Header.jsx";
import Banner from "./Banner.jsx";
import hyperlinks from "../../../src/util/hyperlinks";

export default class YourAccount extends Component {
    render() {
        return (
            <Header showCorporateMembers={this.props.showCorporateMembers} currentUser={this.props.currentUser}>
                <Grid className="with-background your-account-page">
                    <Banner heading="Your Account" />
                    <Row>
                        <Col md={4}>
                            <div className="details">
                                <div className="name">{`${this.props.currentUser.first_name} ${this.props.currentUser.last_name}`}</div>
                                <div className="email">{this.props.currentUser.email}</div>
                            </div>
                        </Col>
                        <Col md={8}>
                            <div className="utility-update">
                                <div>Please use the <a href={hyperlinks["contactUs"]}>contact form</a> to notify us of any alterations that need to be made to your organisation's details.</div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>
                            <div className="update-details">
                                <ul>
                                    <li onClick={this.props.updateEmail}>Change e-mail address</li>
                                    <li onClick={this.props.updateName}>Change name</li>
                                    <li onClick={this.props.updatePassword}>Change password</li>
                                </ul>
                                {this.props.children}
                            </div>
                        </Col>
                        <Col md={8}>
                            <div className="messages">
                                <a href="https://leading-utilities-of-the-world-network.mn.co/sign_in?from=https%3A%2F%2Fleading-utilities-of-the-world-network.mn.co%2Ffeed" target="_blank">Your messages</a>
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </Header>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/YourAccount.jsx.erb